/**
 * @Author: wuyang
 * @Date: 2024/1/11
 * @Description: ""
 */
import {
	ITaskListServiceProps,
	TaskListService
} from '@/helper/services/task-list/TaskListService'
import { createSocketService } from '@/helper/services/socket/SocketService'
import { ESocketPushType } from '@/types/socket'

// 初始化 任务列表时，绑定 socket 相关的任务
//补充 new TaskListService 向它传递一个props里面包含当前任务类型，任务服务实例
export const createTaskListService = (props: ITaskListServiceProps) => {
	//创建socket链接
	const socketService = createSocketService({})

	const taskListService = new TaskListService({
		type: props.type,
		asyncInit: false,
		handleMitt: {
			onStatusChange({ taskId, status }) {
				taskListService.updateTaskById(taskId, { status })
				// 添加刷新逻辑确保列表更新
				taskListService.refresh().catch(console.error)
			}
		}
	})

	socketService.on(ESocketPushType.seg, (data) => {
		taskListService.mitt.emit('onStatusChange', {
			taskId: data.taskId,
			status: data.status
		})
	})

	socketService.on(ESocketPushType.taskStatus, (data) => {
		taskListService.mitt.emit('onStatusChange', {
			taskId: data.taskId,
			status: data.status
		})
	})

	taskListService.addBeforeDestoryCallback(() => {
		socketService.destory()
	})

	return taskListService
}
